<script lang="ts">
  import type { IFormChoiceNode, PartialNode } from "@shared/common/node/type";
  import { onDestroy, onMount } from "svelte";
  import detectReaction from "../../actions/detect-reaction";
  import {
    getCurrentDocumentNode,
    getFormContext,
    getOrInitCheckboxItem,
    getStore,
  } from "../../context";

  import { generateFormDataName } from "@shared/common/utils/form";
  import FormChoiceOption from "./form/form-choice-option.svelte";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener, t } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormChoiceNode>;

  const { checkboxMap } = getFormContext();

  $: name = generateFormDataName(node);

  onMount(() => {
    if (node.choiceType === "CHECKBOX") {
      const item = getOrInitCheckboxItem(checkboxMap, name);
      item.required = node.required || false;
      item.max = node.range?.type === "RANGE" ? node.range.max : undefined;
    }
  });

  onDestroy(() => {
    if (node.choiceType === "CHECKBOX") {
      checkboxMap.delete(name);
    }
  });
</script>

<div
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
>
  <FormLabel label={node.label} required={node.required} />
  {#if node.choiceType === "CHECKBOX" && node.range?.type === "RANGE" && typeof node.range.max === "number"}
    <span class="form-choice-limit">
      {$t("common.inputMaxChoice", { max: node.range.max })}
    </span>
  {/if}

  <div class="form-option-container">
    {#each node.items || [] as item}
      <FormChoiceOption
        {name}
        id={item.id}
        label={item.label}
        required={node.required}
        type={node.choiceType}
      />
    {/each}
  </div>
</div>

<style>
  .form-choice-limit {
    display: block;
    text-align: left;
    color: rgba(var(--cb-form-font-color), 0.7);
    font-size: var(--cb-text-base);
    line-height: var(--cb-line-height-base);
  }

  .form-option-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: calc(var(--cb-form-font-size) * 0.5);
    gap: calc(var(--cb-form-font-size) * 0.5);
  }
</style>
